var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 16,
    viewBox: "0 0 52 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_2118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.734 5.09459C26.7045 7.31454 28.8063 8.55329 30.3896 9.28987C32.0163 10.0455 32.5627 10.5302 32.5563 11.206C32.5441 12.2402 31.2587 12.6967 30.0558 12.7144C27.9573 12.7455 26.737 12.1735 25.767 11.741L25.011 15.1181C25.9843 15.5463 27.7864 15.9196 29.6552 15.936C34.042 15.936 36.9119 13.8688 36.9275 10.6636C36.9447 6.5957 31.0338 6.37054 31.0741 4.55232C31.0881 4.001 31.6391 3.41266 32.8466 3.26307C33.4443 3.1875 35.0942 3.12967 36.9648 3.95203L37.699 0.684564C36.6931 0.334877 35.4001 3.33786e-05 33.7904 3.33786e-05C29.6615 3.33786e-05 26.7574 2.09546 26.734 5.09459ZM44.7538 0.281479C43.9528 0.281479 43.2778 0.727551 42.9765 1.41208L36.7102 15.696H41.0938L41.9661 13.3945H47.3227L47.8287 15.696H51.6923L48.3208 0.281479H44.7538ZM45.3671 4.44553L46.6321 10.2339H43.1675L45.3671 4.44553ZM21.4192 0.281672L17.9639 15.6958H22.1411L25.5948 0.281286H21.4192V0.281672ZM15.2397 0.281286L10.8919 10.7732L9.13318 1.85237C8.92682 0.856516 8.11186 0.281479 7.20684 0.281479H0.0995481L0 0.729094C1.4591 1.03136 3.11688 1.51888 4.12125 2.04051C4.7359 2.35917 4.91117 2.63772 5.1131 3.39493L8.44422 15.696H12.8585L19.6261 0.281479H15.2397",
    fill: "url(#paint0_linear_116_2118)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_2118",
    x1: 23.765,
    y1: 16.2557,
    x2: 24.2054,
    y2: -0.111947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_2118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.6923,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f7452f5fb41dd434c74a8a96e2478b73.svg";
export { ForwardRef as ReactComponent };